import React from "react";

export function SimplePageGridDivider({children,sidebar}) {

    return <>
        <div className="relative">{children}</div>
        <div className="sticky pt-3 overflow-x-visible pl-2 pr-3 unaty-right-sidebar-spacing hidden lg:block space-y-3 app-page-height  overflow-y-auto">{sidebar}</div>
    </>
}